export default () => ({
  allSites:[],
  allDevices: [],
  selectedProjectsDevices: [],
  selectedDataDevice: null,
  selectedProject: null,
  searchQueryData:{query:'', sort:{icon: 'sort-alphabetical-ascending', text: 'Alphabetical order'}},
  searchProjectQuery: '',
  tableData:[],
  fileOperationsTableData:[],
  tableHeaderData:{
    activeSorted: {
      field: '',
      order: ''
    },
    activeFilterField:'',
    filters:{risk: [], pet: null, dca: null, date: null, time:null, ttc:null, kineticEnergy:null, userTypes:null, type: [], speed: null, direction: null}
  },
  singleUserTableHeaderData:{
    activeSorted: {
      field: '',
      order: ''
    },
    activeFilterField:'',
    filters:{date: null, time: null, userType: null, origin: null, destination: null, incidentType: null}
  },
  currentTablePage: 1
});
